import type * as ents from '@attain-apps/entities'

export interface State {
  /**
   * Contains the results of all evaluations in the current chain
   *
   * For example, a user may first get an
   * {@link ents.core.quiver.Evaluation.Incomplete}, and then when they provide
   * the requested information, they may get another
   * {@link ents.core.quiver.Evaluation.Incomplete} because additional
   * information is required based on their inputs. This may happen multiple
   * times before they get to a {@link ents.core.quiver.Evaluation.Complete}.
   * That entire chain is stored here so that we can go back through the chain
   * if needed
   */
  evaluationChain: readonly ents.core.quiver.Evaluation[]
  /**
   * Contains the current values to be used when evaluating
   */
  variableValues: ents.core.dms.data.query.Variable.Lookup
  /**
   * Indicates an evalution is in process
   */
  isEvaluating: boolean
  /**
   * {@link Error} that occurred during the most recent evaluation
   */
  evaluationError?: Error
  /**
   * Indicates a deployment is in process
   */
  isDeploying: boolean
  /**
   * {@link Error} that occurred during deployment
   */
  deploymentError?: Error
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    evaluationChain: [],
    isDeploying: false,
    isEvaluating: false,
    variableValues: {},
  }
}
